export const APP_STORE_LINK_IMAGE_URL = '/icons/social-media/app-store-play-store-color.svg'
